import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { ROUTES } from '../constants/routes';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [microsoftSsoEnabled, setMicrosoftSsoEnabled] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useContext(AuthContext);
  const sessionExpired = searchParams.get('reason') === 'session';

  useEffect(() => {
    let ignore = false;
    const loadSsoConfig = async () => {
      try {
        const res = await axios.get('/api/auth/sso-config');
        if (!ignore) setMicrosoftSsoEnabled(Boolean(res.data?.microsoftEnabled));
      } catch (_err) {
        if (!ignore) setMicrosoftSsoEnabled(false);
      }
    };
    loadSsoConfig();
    return () => {
      ignore = true;
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await axios.post('/api/auth/login', { email, password });
      login(res.data.user, res.data.token);
      navigate(res.data.user?.must_change_password ? ROUTES.CHANGE_PASSWORD : ROUTES.HOME);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center py-5 px-3 app-login-shell">
      <div className="container app-login-panel mx-auto">
        <div className="text-center mb-4">
          <h1 className="h4 fw-semibold mb-1">Compass App</h1>
          <p className="text-muted small mb-0">Sign in to continue</p>
        </div>
        <div className="card app-card border-0 shadow-lg">
          <div className="card-body p-4 p-md-5">
            {sessionExpired && (
              <div className="alert alert-warning mb-4">
                Your session expired or is no longer valid. Please sign in again.
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label" htmlFor="login-email">Email</label>
                <input
                  id="login-email"
                  type="email"
                  className="form-control"
                  autoComplete="username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label className="form-label" htmlFor="login-password">Password</label>
                <input
                  id="login-password"
                  type="password"
                  className="form-control"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              {error && <div className="alert alert-danger">{error}</div>}
              <button type="submit" className="btn btn-primary w-100 mb-2 py-2">
                Login
              </button>
              {microsoftSsoEnabled && (
                <button
                  type="button"
                  className="btn btn-outline-primary w-100 py-2"
                  onClick={() => setError('Microsoft SSO is enabled but provider flow is not configured yet.')}
                >
                  Continue with Microsoft SSO
                </button>
              )}
            </form>
          </div>
        </div>
        <div className="alert alert-light border mt-4 mb-0 py-3 small text-center">
          Need a password reset? Contact an administrator to reset your account.
        </div>
      </div>
    </div>
  );
}

export default Login; 